import { FunctionalComponent, h, Fragment } from "preact";
import styles from "./styles.css";
import { useAppSelector } from "../../redux/hooks";


const WatermarkOverlay: FunctionalComponent = ({}) => {
    const auth = useAppSelector((state) => state.auth);
    const alias = useAppSelector((state) => state.alias)
    const date = new Date();

    let edgeUser: { user?: { name: string; email: string } } = {}; //TODO: replace with getEdgeUserLoginSession(...)
    const data = localStorage.getItem("Web-app-edgeUser");

    try {
        if (data) {
            edgeUser = JSON.parse(data) as (typeof edgeUser)
        }
    } catch { }


    const email = auth.auth0User?.email ?? auth.korraUser?.email ?? edgeUser?.user?.email;
    const name = auth.auth0User?.name ?? edgeUser?.user?.name ?? "Unknown User";

    const formattedDateTime = `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;

    const line1 = "Applied Material Confidential Use Only";
    const line2 = formattedDateTime;
    const line3 = name + " " + email;

    const applied = ["67b9703f2ea7728ebfb05d67", "671505dfbc426e5ac9125493", "67b9703f2ea7728ebfb05d68", "67b9703f2ea7728ebfb05d69"]

    const finalLine1 = applied.includes(alias.workspaceId) ? line1 : null;
    const repetitions = 50;
    const units = Array.from({ length: repetitions }).map((_, index) => (
        <div key={index} className={styles.watermarkUnit}>
            {line1 && <p className={styles.watermarkLine}>{(line1 + " ").repeat(30)}</p>}
            <p className={styles.watermarkLine}>{(line2 + " ").repeat(30)}</p>
            <p className={styles.watermarkLine}>{(line3 + " ").repeat(30)}</p>
        </div>
    ));

    return (
        <div className={styles.watermarkOverlay}>
            {units}
        </div>
    );
}

export default WatermarkOverlay;